import moment from "moment";

/**
 * 값이 입력되어 있는지 확인한다. (0 은 유효한 값으로 취급하지 않는다)
 * @param {*} value
 * @returns {boolean}
 */
export function hasHealthInfoValue(value) {
  return value !== "" && value !== null && value !== undefined;
}

/**
 * 건강정보(수축/이완)의 입력여부와 유효기간을 확인한다.
 * 필수 입력 항목은 아니며, 안내 문구만 표시하기 위해 사용한다.
 * @param {string} 유효기간
 * @param {number|string} 수축
 * @param {number|string} 이완
 * @returns {string[]} 안내 문구 목록
 */
export function checkHealthInfoExpiration(유효기간, 수축, 이완) {
  const today = moment();
  const expirationDate = moment(유효기간);

  const healthInfoError = [];

  if (!수축 || !이완) {
    healthInfoError.push("건강정보를 입력해주세요.");
  }

  if (expirationDate.isBefore(today, "day")) {
    healthInfoError.push("건강정보 유효기간이 만료되었습니다.");
  }

  return healthInfoError;
}
